module.exports = __webpack_public_path__ + "img/logo_2.62637eaf.png";